import React, { useEffect, useState } from "react";
import { Form, Button, Row, Col, Card, Spinner } from "react-bootstrap";
import { CircularProgress } from "@material-ui/core";
import styled from "styled-components";
import moment from "moment";
import { getParameterByName } from "../../../Utils/location";
import { apiGetProgramme, apiCheckinParticipant } from "../../../datasources/programmeEventRepo";

const CONTAINER = styled.div`
  .error {
    border: 1px solid #ff6565;
  }
`;

export function AttendanceProgrammeEventsPage() {
  const [idEvent, setIdEvent] = useState(null);
  const [dataEvent, setDataEvent] = useState(null);
  const [email, setEmail] = useState('');
  const [formState, setFormState] = useState({
    loading: false,
    error: false,
    message: null
  })
  const [resAttendance, setResAttendance] = useState(null);

  useEffect(() => {
    let idEvent = getParameterByName('id');
    setIdEvent(idEvent);
    getProgramme(idEvent);
  }, []);

  function getProgramme(idEvent){
    setFormState({
      ...formState,
      loading: true
    })
    apiGetProgramme({id: idEvent}).then((res) => {
      setFormState({
        ...formState,
        loading: false
      })
      setDataEvent(res.data);
      console.log(res);
    }).catch(err => {
      console.log(err);
      setFormState({
        ...formState,
        loading: false,
        error: true,
        message: err?.response?.data?.message
      })
    })
  }

  function submitData(){
    let payload = {
      id: idEvent,
      email: email,
    }
    console.log(payload);
    setFormState({
      ...formState,
      loading: true
    })
    apiCheckinParticipant(payload).then((res) => {
      console.log(res);
      setFormState({
        ...formState,
        loading: false,
        error: false,
        message: res?.data?.message
      })
    }).catch(err => {
      console.log(err);
      setFormState({
        ...formState,
        loading: false,
        error: true,
        message: err?.response?.data?.message
      })
    })
  }

  return (
    <div
      className="d-flex align-item-center justify-content-center"
      style={{
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          height: "100vh",
          width: "100vw",
          backgroundImage: `url(assets/images/hold_heart.png)`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          filter: "blur(8px)",
          position: "absolute",
        }}
      />
      <Card style={{ width: "45rem", height: "25rem"}}>
        <Card.Header>
          <div className="col-lg-12 justify-content-center align-items-center d-flex">
            <div className="col-lg-2">
              <img
                alt="Logo"
                src={'assets/images/logo-interaktiv.png'}
                style={{
                  maxHeight: "45px",
                }}
              />
            </div>
            <div className="col-lg-8">
              <h5 className="text-center ">Attendance Programme Events</h5>
            </div>
            <div className="col-lg-2" />
          </div>
        </Card.Header>
        <Card.Body>
          <CONTAINER>
            {dataEvent !== null ? (
              <Form>
                <Form.Group as={Row} className={"mb-1"}>
                  <Col lg={2} xs={0}/>
                  <Col lg={4} xs={6}>
                    <Form.Group>
                      <Form.Label style={{fontWeight: 'bold'}}>
                        Subject
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col lg={6} xs={6}>
                    <Form.Group>
                      <Form.Label>{dataEvent?.Ttile__c}</Form.Label>
                    </Form.Group>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className={"mb-1"}>
                  <Col lg={2} xs={0}/>
                  <Col lg={4} xs={6}>
                    <Form.Group>
                      <Form.Label style={{fontWeight: 'bold'}}>
                        Start Date
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col lg={6} xs={6}>
                    <Form.Group>
                      <Form.Label>
                        {moment(dataEvent?.Start_Date_Time__c).format("DD MMMM YYYY hh:mm A")}
                      </Form.Label>
                    </Form.Group>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className={"mb-1"}>
                  <Col lg={2} xs={0}/>
                  <Col lg={4} xs={6}>
                    <Form.Group>
                      <Form.Label style={{fontWeight: 'bold'}}>
                        End Date
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col lg={6} xs={6}>
                    <Form.Group>
                      <Form.Label>
                        {moment(dataEvent?.End_Date_Time__c).format("DD MMMM YYYY hh:mm A")}
                      </Form.Label>
                    </Form.Group>
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className={"mb-1"}>
                  <Col lg={2} xs={0}/>
                  <Col lg={4} xs={6}>
                    <Form.Group>
                      <Form.Label style={{fontWeight: 'bold'}}>
                        Volunteer Location
                      </Form.Label>
                    </Form.Group>
                  </Col>
                  <Col lg={6} xs={6}>
                    <Form.Group>
                      {
                        dataEvent?.Venue__c !== "" && dataEvent?.Venue__c?.includes("http") ?
                        <a href={dataEvent?.Venue__c} target="_blank">
                          <Form.Label style={{
                            color: 'blue',
                            textDecorationLine: 'underline',
                            cursor: 'pointer'
                          }}>{dataEvent?.Venue__c}</Form.Label>
                        </a> :
                        <Form.Label>{dataEvent?.Venue__c ? dataEvent?.Venue__c : 'N/A'}</Form.Label>
                      }
                    </Form.Group>
                  </Col>
                </Form.Group>
                <Form.Group 
                  as={Row}
                  className={'align-items-center justify-content-center mb-5 mt-3'}
                >
                  <Col lg={12} xs={12} className={"align-items-center justify-content-center d-flex"}>
                    <Form.Text 
                      as={Row}
                      className={`${formState.error ? 'text-danger' : 'text-success'} mt-0 mb-0 align-items-center justify-content-center d-flex`}
                    >
                      { formState.message }
                    </Form.Text>
                  </Col>
                  <Col lg={8} xs={12} className={"align-items-center justify-content-center d-flex mt-2"}>
                    <Form.Control 
                      type="email" 
                      placeholder="email" 
                      style={{ width: "50%" }}
                      onChange={(e) => {
                        setEmail(e.target.value);
                      }}
                      disabled={resAttendance !== null}
                    />
                  </Col>
                  <Col lg={8} xs={12} className={"align-items-center justify-content-center d-flex mt-2"}>
                    <Button
                      variant={"primary"}
                      style={{ width: "auto", maxWidth: "50%", minWidth: "50%" }}
                      onClick={() => submitData()}
                      disabled={formState.loading}
                    >
                      Submit
                      {
                        formState.loading &&
                        <Spinner animation="border" role="status" size="sm">
                          <span className="visually-hidden">Loading...</span>
                        </Spinner>
                      }
                    </Button>
                  </Col>
                </Form.Group>
              </Form>
            ) : (
              <div
                style={{
                  width: "100%",
                  height: "50%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            )}
          </CONTAINER>
        </Card.Body>
      </Card>
    </div>
  );
}